/**
 * Sort for the Outside the Ranch list on Places.
 *
 * Distance uses the same miles-from-home figure the cards already show
 * (`distance_from_home_miles`). A place with no distance goes last.
 * Alphabetical is A to Z by name. Inside-the-Ranch lists do not use this.
 */

export type OutsideSort = 'distance' | 'alphabetical';

export function parseOutsideSort(value: string | null | undefined): OutsideSort {
  return value === 'alphabetical' ? 'alphabetical' : 'distance';
}

type SortablePlace = {
  name: string;
  distance_from_home_miles?: number | null;
};

function distanceOrLast(miles: number | null | undefined): number {
  return miles == null || !Number.isFinite(miles) ? Number.POSITIVE_INFINITY : miles;
}

export function sortOutsidePlaces<T extends SortablePlace>(places: readonly T[], sort: OutsideSort): T[] {
  const list = [...places];
  if (sort === 'alphabetical') {
    list.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    return list;
  }
  list.sort((a, b) => distanceOrLast(a.distance_from_home_miles) - distanceOrLast(b.distance_from_home_miles));
  return list;
}
